import React, { useEffect, useState } from 'react'

// estilos
import './contacts.css';
import '../../assets/style/componentPrincipal.css'

// import { fetchConToken } from '../../helpers/fetch'

// componentes
import { Buscar } from '../general/buscadorNew/Buscar'
import { Crear } from '../contactos/Crear'

import { GridMode } from './GridMode'
import { ModalProgress } from '../modals/ModalProgress'
import { ExportarPlanilla } from '../general/exportarPlanilla/ExportarPlanilla'
// import { VerReporte } from '../general/verReporte/VerReporte'
import { DialogProfileContact } from './DialogProfileContact'
import { Contacts } from './model'
// import { ListMode } from './ListMode';
// import { Link } from 'react-router-dom';

const intialFilters = {
    check_estado: true,
    check_activo: true,
    check_desactivo: false,
    text: '',
    check_clientes: true,
    check_proveedores: true,
    check_personas: true,
    check_empresas: true,
    page: 1,
    rows: 20,
    buscar: false
}

export const ContactList = () => {

    const [list, setList] = useState([])
    const [loading, setLoading] = useState(false)
    const [open, setOpen] = useState(false)
    const [initialState, setInitialState] = useState({})

    const [searching, setSearching] = useState({
        initial: intialFilters,
        placeholder: 'Buscar en contactos',
        filters: intialFilters
    })

    useEffect(() => {
        getAll(intialFilters)
    }, [])

    useEffect(() => {
        if (searching.filters.buscar === true) {
            getAll(searching.filters)
        }
    }, [searching])

    const getAll = async (filters) => {
        setLoading(true)
        const results = await Contacts.getAll(filters)
        console.log({ results })
        setList(results)
        setLoading(false)
    }

    const getOne = async (id) => {
        let data = await Contacts.getOne(id)

        if (data.tipo === '' || data.tipo === null) {
            data.tipo = 'empresa'
        }

        setInitialState(data)
        setOpen(true)
    }

    return (
        <div className='p-container'>
            <h1 className='p-title'>Contactos</h1>

            <div className='row p-box-searching'>
                <div className='col d-flex'>
                    <Buscar
                        searching={searching}
                        setSearching={setSearching}
                    />
                    <div className='p-box-crear'>
                        <Crear />
                    </div>
                </div>
                <div className='col d-flex justify-content-end'>
                    <ExportarPlanilla
                        filters={searching.filters}
                    />
                    {/* <VerReporte /> */}
                </div>
            </div>

            {loading && <ModalProgress />}

            {/* <ListMode list={list} /> */}

            <div className='row'>
                <div className='col d-flex flex-wrap justify-content-start'>
                    {list.length > 0 && list?.map(p => (
                        <div key={p.id} onClick={() => getOne(p.id)}>
                            <GridMode
                                item={p}
                                key={p.id}
                            />
                        </div>
                    ))}
                </div>
            </div>

            {open && (
                <DialogProfileContact
                    open={open}
                    setOpen={setOpen}
                    initialState={initialState}
                />
            )}

        </div >
    )
}
